import { moduleProviderFactory } from 'core/providers';
import { ScheduleList, ScheduleCalendar } from 'application/schedule/pages';

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: 'master.app.main.schedule',
                pattern: '/schedules',
                children: [
                    {
                        name: 'master.app.main.schedule.list',
                        authorization: 'calendarSection.read',                        
                        pattern: '',
                        component: ScheduleList,
                        data: {
                            title: 'SCHEDULE.LIST.TITLE'
                        }
                    },
                    {
                        name: 'master.app.main.schedule.calendar',
                        authorization: 'calendarSection.read',                        
                        pattern: '/calendar',
                        component: ScheduleCalendar,
                        data: {
                            //title: 'SCHEDULE.CALENDAR.TITLE'
                        }
                    }           
                ]
            }
        ],
        menu: [
           {
               title: 'MENU.SCHEDULES',
               route: 'master.app.main.schedule.calendar',
               icon:  'calendar-edit',
               order: 3
            }
        ] 
    });
})();
